import React from 'react';
import { Grid, Typography } from '@mui/material';
import AvatarSection from './AvatarSection';
import EditableBox from './EditableBox';

// Component for GIF template
const GifTemplateContent = (props:any) =>
{
	const { downSM, requestT, viewData, textState, occasionData, handleAttendees,
		handleChange, avatarList, selectEvent, handleRemove, hasGifTemplate } = props;

	return (
		<Grid container p={downSM ? 1 : 2} display={'flex'} alignItems={'center'}>
			<Grid item xs={12} display={'flex'} justifyContent={'center'}>
				{requestT === 'viewEvent' && Boolean(viewData?.occasion?.title)
					? <Typography color={'rgba(37, 110, 166, 1)'} fontSize={downSM ? 14 : 28} fontWeight={500}> { viewData?.occasion?.title}</Typography>
					: <EditableBox content={textState?.title || occasionData?.title} char={50} clr={'#256EA6'} txtAln='start' fontsize={'18px'} placeholder={`Celebrating ${occasionData?.type}`} updateText={(event) => { handleChange(event, 'title'); }} hasGifTemplate={hasGifTemplate} />
				}
			</Grid>
			<Grid item xs={12} display={'flex'} justifyContent={'center'}>
				{!selectEvent && (
					<Typography
						color={'rgba(83, 100, 113, 1)'}
						fontSize={downSM ? 10 : 18}
						fontWeight={500}
						textAlign={'center'}
					>
						Cheers to new beginnings! Let&apos;s make this project a success.
					</Typography>
				)}
				{selectEvent && (
					requestT === 'viewEvent' && Boolean(viewData?.occasion?.text)
						? <Typography color={'rgba(37, 110, 166, 1)'} fontSize={downSM ? 28 : 14} fontWeight={500}> {viewData?.occasion?.text}</Typography>
						: <EditableBox content={textState?.text !== '' ? textState?.text : occasionData?.text} char={80} clr={'#256EA6'} txtAln='start' fontsize={'14px'} placeholder='Enter your greeting message...' updateText={(event) => { handleChange(event, 'text'); }} hasGifTemplate={hasGifTemplate} />
				)}
			</Grid>
			{/* Avatar section */}
			<AvatarSection
				avatarList={avatarList}
				selectEvent={selectEvent}
				requestT={requestT}
				downSM={downSM}
				handleRemove={handleRemove}
				handleAttendees={handleAttendees}
			/>
		</Grid>
	);
};

export default GifTemplateContent;